module.exports = __webpack_public_path__ + "static/media/1.2ad0c1be.png";